import React, { useState } from 'react'
import { Dropdown, Icon } from 'semantic-ui-react'

import { useMeleeContext } from './context/MeleeContextProvider'

import { UndoAction } from './utils/roundHandler'

import TierListModal from './modals/tierListModal'

import ConfirmModal from '../tour/utils/ConfirmModal'
import { useNavigate } from 'react-router-dom'

const GameMenu = () => {
  const meleeContext = useMeleeContext();
  const navigate = useNavigate();

  const [tierListModalOpen, setTierListModalOpen] = useState(false);

  const [confirmRevertModalOpen, setConfirmRevertModalOpen] = useState(false)
  const [confirmResetModalOpen, setConfirmResetModalOpen] = useState(false)

  const resetGameOnClick = () => {
    let disabledRound = Object.assign({}, meleeContext?.gameData);
    disabledRound.Active = false;
    meleeContext?.setGameData(disabledRound);
  }

  const revertState = () => {
    if (meleeContext && meleeContext.gameData.History) {
      const prevState = UndoAction(meleeContext.gameData)
      meleeContext.setGameData(prevState)
    }
  }

  const openTierListModal = () => {
    setTierListModalOpen(true);
  }

  const homeOnClick = () => {
    navigate("/");
  }

  const hasHistory = meleeContext!.gameData.History && meleeContext!.gameData.History!.length > 0

  return (
    <>
      <Dropdown text='Menu' className="melee-inline-dropdown">
        <Dropdown.Menu>

          {meleeContext && meleeContext.gameData.Active ? (
            <>

              {hasHistory &&
                <Dropdown.Item icon='undo' text='Undo' onClick={() => setConfirmRevertModalOpen(true)} />
              }

              <Dropdown.Item icon='trash' text='Abandon' onClick={() => setConfirmResetModalOpen(true)} />
            </>
          ) : (
            <>
              <Dropdown.Item icon='home' text="Home" onClick={() => homeOnClick()} />
            </>
          )
          }
          <Dropdown.Item icon='pie graph' text='Tier List' onClick={() => openTierListModal()} />
          <Dropdown.Item icon='arrow circle left' text='Back' onClick={() => navigate(-1)} />

        </Dropdown.Menu>
      </Dropdown>

      <ConfirmModal
        header={"Undo Action"}
        isOpen={confirmRevertModalOpen}
        onAccept={revertState}
        textContent={"Are you sure you want to undo last action? \nRandom events will reset"}
        toggleOpen={setConfirmRevertModalOpen}
        icon={<Icon name='undo' />}
      />

      <ConfirmModal
        header={"Abandon Game"}
        isOpen={confirmResetModalOpen}
        onAccept={resetGameOnClick}
        textContent={"Are you sure you want to abandon this game?"}
        toggleOpen={setConfirmResetModalOpen}
        icon={<Icon name='trash' />}
      />

      <TierListModal
        open={tierListModalOpen}
        setOpen={setTierListModalOpen}
      />
    </>
  )
}

export default GameMenu;